/**
 * A jegy (`support/tickets`) zárt értékkészletei — EGY forrás a belső és a partner-szerződésnek, a BFF-nek és a
 * felületnek (előtte négy kézzel írt másolat élt a contracts-ban).
 *
 * Az Odin Schema Registry PONTOSAN ezt a két enumot validálja (422) — Odin `20261103100000` migráció. A két lista
 * két külön deployban él, ezért a sorrend számít (`docs/building-on-odin.md` §8 „Enum-mező bővítése és
 * szűkítése"):
 *   • új érték: ELŐBB az Odin (új registry-verzió), UTÁNA ez a lista + az i18n-címke;
 *   • érték kivezetése: ELŐBB az adat átírása, UTÁNA a szűkebb séma — és csak azután innen.
 */
export const TICKET_TYPES = ['support', 'bug', 'feature_request', 'billing', 'other'];
/** A legacy enum 1:1. Az életciklus-csoportokat a contracts `TICKET_GROUP_STATUSES`-e adja. */
export const TICKET_STATUSES = ['open', 'in_progress', 'resolved', 'closed', 'reopened'];
//# sourceMappingURL=ticket-enums.js.map